import React, { useState, useEffect } from 'react';
import './FloatingNav.css';
import { AiOutlineHome } from 'react-icons/ai';
import { AiOutlineUser } from 'react-icons/ai';
import { RiServiceLine } from 'react-icons/ri';
import { BiBook } from 'react-icons/bi';
import { BiMessageSquareDetail } from 'react-icons/bi';

const FloatingNav = () => {
  const [activeNav, setActiveNav] = useState('#');

  const handleScroll = () => {
    const aboutSection = document.getElementById('About');
    const portfolioSection = document.getElementById('Portfolio');
    const servicesSection = document.getElementById('Services');
    const contactSection = document.getElementById('Contact');

    const scrollY = window.scrollY;

    if (scrollY >= 0 && scrollY < aboutSection.offsetTop) {
      setActiveNav('#');
    } else if (
      scrollY >= aboutSection.offsetTop &&
      scrollY < portfolioSection.offsetTop
    ) {
      setActiveNav('#About');
    } else if (
      scrollY >= portfolioSection.offsetTop &&
      scrollY < servicesSection.offsetTop
    ) {
      setActiveNav('#Portfolio');
    } else if (
      scrollY >= servicesSection.offsetTop &&
      scrollY < contactSection.offsetTop
    ) {
      setActiveNav('#Services');
    } else {
      setActiveNav('#Contact');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className='floating_nav'>
      <a
        href="#"
        onClick={() => setActiveNav('#')}
        className={activeNav === '#' ? 'active' : ''}
      >
        <AiOutlineHome />
      </a>
      <a
        href="#About"
        onClick={() => setActiveNav('#About')}
        className={activeNav === '#About' ? 'active' : ''}
      >
        <AiOutlineUser />
      </a>
      <a
        href="#Portfolio"
        onClick={() => setActiveNav('#Portfolio')}
        className={activeNav === '#Portfolio' ? 'active' : ''}
      >
        <BiBook />
      </a>
      <a
        href="#Services"
        onClick={() => setActiveNav('#Services')}
        className={activeNav === '#Services' ? 'active' : ''}
      >
        <RiServiceLine />
      </a>
      <a
        href="#Contact"
        onClick={() => setActiveNav('#Contact')}
        className={activeNav === '#Contact' ? 'active' : ''}
      >
        <BiMessageSquareDetail />
      </a>
    </div>
  );
};

export default FloatingNav;
